import React from 'react';

import ContentLoader from '@adsk/alloy-react-content-loader';

const ProjectLoader = () => (
  <ContentLoader width={150} height={35} viewBox="0 0 150 32">
    <rect x="35" y="12" rx="3" ry="3" width="100" height="8" />
    <rect x="0" y="0" rx="8" ry="8" width="32" height="32" />
  </ContentLoader>
);

ProjectLoader.displayName = 'ProjectLoader';

export default ProjectLoader;
